const o="__uxl_regions__",s=i=>(n,r)=>{n.constructor[o]={...n.constructor[o],[r]:i}};export{s as region,o as regionsProperty};
